import { render, staticRenderFns } from "./HowToBuyTimePage.htm?vue&type=template&id=b6df2b14&scoped=true&external"
import script from "./HowToBuyTimePage.js?vue&type=script&lang=js&external"
export * from "./HowToBuyTimePage.js?vue&type=script&lang=js&external"
import style0 from "./HowToBuyTimePage.scss?vue&type=style&index=0&id=b6df2b14&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6df2b14",
  null
  
)

export default component.exports